module.exports = __webpack_public_path__ + "static/media/photo185.10de05b8.jpg";